import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import Loadercomponent from "../../../Componets/Loader";
import toast from "react-hot-toast";
import { Button, Tag, Alert } from "antd";
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  PrinterOutlined,
  DownloadOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  get_comprehensive_product_reports
} from "../../../Controllers/Dashboard/Dashboard";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import { resolveTransactionType } from "../../../Main/resolveTransactionType";
import { Tooltip } from "antd";
import Divider from "../../../Componets/Divider/Divider";
import Table from "../../../Componets/Table"

const StockLedgerReport = () => {
  let componentRef = useRef();
  const [loader, setLoader] = useState(false);
  const [stockData, setStockData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [productSearchAlert, setProductSearchAlert] = useState(false);
  const [productInfo, setProductInfo] = useState({ name: null, item_code: null });
  const [body, setBody] = useState([]);
  const PAGE_SIZE = 50;
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    totalCount: 0,
    pageSize: PAGE_SIZE
  });


  const headers = {
    name: "Stock Ledger Report",
    components: [
      /* {
        type: "search",
        name: "search",
        placeholder: "Search by Product Name",
        value: "",
      }, */
      {
        type: "filter",
        name: "product",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Product",
        api: "get-all-products",
        value: null,
        options: null,
        className: "w-72",
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Stock Ledger",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total Transactions" },
        { value: 0, label: "Inflow" },
        { value: 0, label: "Outflow" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const tables = [
    { name: "Date & Time", key: "Date & Time" },
    { name: "Product", key: "Products" },
    { name: "Movement", key: "Movements" },
    { name: "Current Inventory stock", key: "Current Inventory Stock" },
    { name: "User", key: "User" },
    { name: "Details", key: "Details" },
  ];

  const computeQuantity = (type, quantity, isDelete = false, conversion) => {
    switch (type) {
      case "inventory":
        return isDelete ? -Math.abs(quantity) : Math.abs(quantity);
      case "purchase":
        return isDelete ? -Math.abs(quantity) : Math.abs(quantity);
      case "purchase_return":
        return isDelete ? Math.abs(quantity) : -Math.abs(quantity);
      case "transfer":
        return isDelete ? Math.abs(quantity) : -Math.abs(quantity);
      case "receive":
        return isDelete ? Math.abs(quantity) : -Math.abs(quantity);
      case "received_current":
        return Math.abs(quantity);
      case "sale":
        return -Math.abs(quantity);
      case "sales_return":
        return conversion > 0 ? Math.abs(quantity * conversion) : Math.abs(quantity);
      default:
        return quantity;
    }
  };

  const getSafeTimestamp = (entry) => {
    if (Number.isFinite(entry.timestamp)) {
      return entry.timestamp;
    }

    if (entry.date) {
      const t = new Date(entry.date).getTime();
      if (!Number.isNaN(t)) return t;
    }

    return null;
  };

  const processStockData = (apiData) => {
    const stockEntries = [];
    let productList = new Set();

    const addEntry = (type, item, quantity, stockAfter, units, foc, date, info, details = {}) => {

      const entryDate = new Date(item.created || item.createdAt || item.date);
      const formattedDate = dayjs(entryDate).format("YYYY-MM-DD HH:mm:ss");

      const { action, entity } = resolveTransactionType(info?.endpoint);

      let transactionLabel = "";
      switch (type) {
        case "received":
          transactionLabel = "STOCK RECEIVED (FROM OTHER BRANCH)";
          break;
        case "received_current":
          transactionLabel = "STOCK RECEIVED (CURRENT BRANCH)";
          break;
        default:
          transactionLabel = action !== "UNKNOWN"
            ? `${action.replace("_", " ")} ${entity.replace("_", " ")}`
            : type.replace("_", " ").toUpperCase();
      }

      stockEntries.push({
        key: `${type}_${item._id}_${entryDate.getTime()}`,
        date: formattedDate,
        timestamp: entryDate,
        type: transactionLabel,
        number: item.number,
        foc: foc,
        productName: item.name || item.product?.name || info.name || "N/A",
        batchNumber: info?.number || info?.inventory?.number || "N/A",
        endpoint: info?.endpoint,
        stockAfter: stockAfter || 0,
        units: units || [],
        ismainunit: info?.description ? info?.description === info?.unit : !(parseFloat(quantity) % 1 !== 0),
        expiryDate: info?.expiry_date
          ? dayjs(info.expiry_date).format("YYYY-MM-DD")
          : info?.inventory?.expiry_date
            ? dayjs(info.inventory.expiry_date).format("YYYY-MM-DD")
            : "N/A",
        productId: item._id || item.product?._id,
        reference: item.number || item.invoice || `#${type.slice(0, 3).toUpperCase()}`,
        quantity: Math.abs(quantity),
        movement: quantity > 0 ? "in" : "out",
        unit: "pcs",
        details: details,
        user: item.user?.name || "System",
        branch: item.branch?.name || "Main Branch"
      });

      productList.add(item.name || item.product?.name || details.productName);
    };

    if (apiData.data?.product_details) {
      apiData.data.product_details.forEach(product => {
        const Units = product.unit_detail_log.map(unit => ({
          _id: unit._id,
          name: unit.name,
          conversion: unit.conversion
        }));
        addEntry("product_created", product, 0, product.current_stock, Units, 0, product.created, product, {
          operation: "Product Created",
          price: product.sale_price,
          status: product.status === 1 ? "Active" : "Inactive"
        });
      });
    }

    if (apiData.data?.inventory_details) {
      apiData.data.inventory_details.forEach(inv => {
        const isDeleted = inv.endpoint === "/api/delete-inventory" === true || false;
        const quantity = computeQuantity("inventory", inv.stock, isDeleted);
        const Units = inv.units.map(unit => ({
          _id: unit._id,
          name: unit.name,
          conversion: unit.conversion
        }));
        const isNegative = inv?.stock_change ? inv.stock_change.startsWith('-') : false;
        addEntry("inventory", inv, inv.stock_change, isNegative ? 0 : inv.stock, Units, 0, inv.createdAt, inv, {
          operation: inv?.note ? inv?.note : "Stock Addition",
          purchasePrice: inv.purchase_price,
          salePrice: inv.sale_price,
          expiry: inv.expiry_date ? dayjs(inv.expiry_date).format("YYYY-MM-DD") : null,
        });
      });
    }

    if (apiData.data?.sales_details) {
      apiData.data.sales_details.forEach(sale => {
        sale.details?.forEach(detail => {
          const isDeleted = sale.endpoint === "/api/delete-invoice" === true || false;
          const quantity = computeQuantity("sale", detail.quantity, isDeleted);
          const Units = detail.units.map(unit => ({
            _id: unit._id,
            name: unit.name,
            conversion: unit.conversion
          }));
          addEntry("sale", sale, quantity, detail.inventory_stock_after, Units, detail?.free > 0 ? detail?.free : 0, sale.date, detail, {
            operation: "Sales Invoice",
            invoiceNumber: sale.number,
            customer: sale.customer?.name || "Walk-in Customer",
            amount: sale.total
          });
        });
      });
    }

    if (apiData.data?.sales_return_details) {
      apiData.data.sales_return_details.forEach(returnItem => {
        returnItem.details?.forEach(detail => {
          const isDeleted = returnItem.endpoint === "/api/delete-sales-return" === true || false;
          const quantity = computeQuantity("sales_return", detail.quantity, isDeleted, detail.conversion);
          const Units = [{
            _id: detail.unit,
            name: "Unknown Unit",
            conversion: detail.conversion
          }];
          addEntry("sales_return", returnItem, quantity, detail.inventory_stock_after, Units, detail?.free > 0 ? detail?.free : 0, returnItem.date, detail, {
            operation: "Sales Return",
            returnNumber: returnItem.number,
            reason: "Customer Return"
          });
        });
      });
    }

    if (apiData.data?.purchase_order_details) {
      apiData.data.purchase_order_details.forEach(purchase => {
        purchase.details?.forEach(detail => {
          const isDeleted = purchase.endpoint === "/api/delete-purchase-order" === true || false;
          const quantity = computeQuantity("purchase", detail.quantity, isDeleted);
          const Units = detail.units.map(unit => ({
            _id: unit._id,
            name: unit.name,
            conversion: unit.conversion
          }));

          addEntry("purchase", purchase, quantity, detail.inventory_stock_after, Units, detail?.free > 0 ? detail?.free : 0, purchase.date, detail, {
            operation: "Purchase Order",
            purchaseNumber: purchase.number,
            supplier: purchase.supplier?.name || "Supplier",
            amount: purchase.total
          });
        });
      });
    }

    if (apiData.data?.purchase_return_details) {
      apiData.data.purchase_return_details.forEach(returnItem => {
        returnItem.details?.forEach(detail => {
          const isDeleted = returnItem.endpoint === "/api/delete-purchases-return" === true || false;
          const quantity = computeQuantity("purchase_return", detail.quantity, isDeleted);
          const Units = [{
            _id: detail.unit,
            name: "Unknown Unit",
            conversion: detail.conversion
          }];
          addEntry("purchase_return", returnItem, quantity, detail.inventory_stock_after, Units, detail?.free > 0 ? detail?.free : 0, returnItem.date, detail, {
            operation: "Purchase Return",
            returnNumber: returnItem.number,
            supplier: returnItem.supplier?.name || "Supplier"
          });
        });
      });
    }

    if (apiData.data?.transfer_details) {
      apiData.data.transfer_details.forEach(transfer => {
        transfer.details?.forEach(detail => {
          const isDeleted = transfer.endpoint === "/api/delete-transfer" === true || false;
          const quantity = computeQuantity("transfer", detail.quantity, isDeleted);
          const Units = detail.units.map(unit => ({
            _id: unit._id,
            name: unit.name,
            conversion: unit.conversion
          }));
          addEntry("transfer", transfer, quantity, detail.inventory_stock_after, Units, 0, transfer.date, detail, {
            operation: "Stock Transfer",
            transferNumber: transfer.number,
            toBranch: transfer.supplier_branch?.name || "Other Branch",
            status: transfer.delivery_status === 2 ? "Delivered" : "Pending"
          });
        });
      });
    }

    if (apiData.data?.received_details) {
      apiData.data.received_details.forEach(received => {
        received.details?.forEach(detail => {
          const isDeleted = received.endpoint === "/api/delete-transfer" === true || false;
          const quantity = computeQuantity("received", detail.quantity, isDeleted);
          const Units = detail.units ? detail.units.map(unit => ({
            _id: unit._id,
            name: unit.name,
            conversion: unit.conversion
          })) : [];
          addEntry("received", received, quantity, detail.source_inventory_stock_after || detail.stock_after,
            Units,
            detail?.free || 0,
            received.date, detail, {
            operation: "Stock received by the branch to which it was transferred",
            receiveNumber: received.number,
            status: received.delivery_status === 2 ? "Delivered" : "Pending",
            sourceStockAfter: detail.source_inventory_stock_after,
            targetStockAfter: detail.target_inventory_stock_after
          });
        });
      });
    }

    if (apiData.data?.received_current_branch_details) {
      apiData.data.received_current_branch_details.forEach(received => {
        received.details?.forEach(detail => {
          const isDeleted = received.endpoint === "/api/delete-transfer" === true || false;
          const quantity = computeQuantity("received_current", detail.quantity, isDeleted);
          const Units = detail.units ? detail.units.map(unit => ({
            _id: unit._id,
            name: unit.name,
            conversion: unit.conversion
          })) : [];
          addEntry("received_current", received, quantity,
            detail.dest_inventory_stock_after,
            Units,
            detail?.free || 0,
            received.date,
            detail, {
            operation: "Transferred stock received by the current branch",
            receiveNumber: received.number,
            status: received.status || received.delivery_status === 2 ? "Delivered" : "Pending",
          }
          );
        });
      });
    }

    stockEntries.sort((a, b) => {
      const ta = getSafeTimestamp(a);
      const tb = getSafeTimestamp(b);

      if (ta === null && tb === null) return 0;
      if (ta === null) return 1;
      if (tb === null) return -1;
      return tb - ta;
    });

    return stockEntries;
  };

  const fetchStockData = async (data) => {
    try {
      setLoader(true);
      const StockMovementAPIReponse = await get_comprehensive_product_reports(data);

      if (StockMovementAPIReponse?.data?.data) {
        const processedData = processStockData(StockMovementAPIReponse.data);

        setStockData(processedData);
        setFilteredData(processedData);
        setProductInfo(StockMovementAPIReponse.data.product || {});

        const inflow = processedData.filter(d => d.movement === "in").length;
        const outflow = processedData.filter(d => d.movement === "out").length;

        setHeader(prev => ({
          ...prev,
          navigate: {
            ...prev.navigate,
            total: [
              { value: processedData.length, label: "Total Transactions" },
              { value: inflow, label: "Inflow" },
              { value: outflow, label: "Outflow" },
            ],
          },
        }));

        const totalPages = Math.ceil(processedData.length / PAGE_SIZE);

        setPagination({
          currentPage: 1,
          totalPages,
          totalCount: processedData.length,
          pageSize: PAGE_SIZE
        });

        setProductSearchAlert(false);

      } else {
        setProductSearchAlert(true);
      }

      setLoader(false);
    } catch (error) {
      toast.error(error.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    setProductSearchAlert(true);
  }, []);

  useEffect(() => {
    if (!filteredData) return;

    const start = (pagination.currentPage - 1) * PAGE_SIZE;
    const end = start + PAGE_SIZE;

    const paginatedData = filteredData.slice(start, end);

    const tableBody = paginatedData.map((record, index) => {

      const d = new Date(record.date);

      const date =
        d.toLocaleDateString("en-GB") +
        " " +
        d.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });


      const qty = record.details?.operation?.startsWith("Inventory reversed due to purchase order") ? record.ismainunit ? record.quantity : record.quantity * (record.units[0]?.conversion || 1) : record.quantity?.toFixed(0);
      const unit = record.ismainunit ? "F" : "L";
      const hasFoc = record.foc > 0;
      const details = record.details;

      return {
        "Date & Time": date,

        Product: (
          <div className="text-xs">
            <div><strong>Batch:</strong> {record.batchNumber}</div>
            <div><strong>Expiry:</strong> {record.expiryDate}</div>
          </div>
        ),

        Movement: (
          <div className="flex items-center">
            {record.movement === "in" ? (
              <>
                <ArrowUpOutlined className="text-green-600 mr-1" />
                <span className="text-green-600 flex items-center">
                  + {qty} {unit}
                  {hasFoc && (
                    <>
                      {/* <Divider type="vertical" className="mx-2" /> */}
                      {" "} & {" "}
                      {record.foc} FOC
                    </>
                  )}
                </span>
              </>
            ) : (
              <>
                <ArrowDownOutlined className="text-red-600 mr-1" />
                <span className="text-red-600 flex items-center">
                  - {qty} {unit}
                  {hasFoc && (
                    <>
                      {/* <Divider type="vertical" className="mx-2" /> */}
                      {" "} & {" "}
                      {record.foc} FOC
                    </>
                  )}
                </span>
              </>
            )}
          </div>
        ),

        "Current Inventory stock": renderStockAfter(record),

        User: record.user,

        Details: (
          <div className="text-xs text-left">
            <div>
              <strong>Op:</strong> {record.type}
            </div>
            {details.receiveNumber && (
              <div><strong>Rec. No:</strong> {details.receiveNumber}</div>
            )}
            {details.operation && (
              <div><strong>Note:</strong> {details.operation}</div>
            )}
            <div dangerouslySetInnerHTML={{ __html: formatOpLabel(record.type, record.number, details.operation) }} />
          </div>
        ),
      };
    });

    setBody(tableBody);

  }, [filteredData, pagination.currentPage]);

  const renderStockAfter = (record) => {

    console.log("qty", record)

    if (!record.units || record.units.length === 0) {
      return `${record.stockAfter} F`;
    }

    if (!record.ismainunit && record.units?.length && record.stockAfter < record.units[0].conversion && !(parseFloat(record.stockAfter) % 1 !== 0)) {
      const unit = record.units[0];
      return `${record.stockAfter} L`;
    }

    const fullQty = Math.floor(record.stockAfter);

    const looseUnits = record.units
      .map(unit => {
        const looseQty = Math.floor(
          ((record.stockAfter - fullQty) * unit.conversion) + 1e-6
        );
        return { ...unit, looseQty };
      })
      .filter(unit => unit.looseQty > 0);

    return (
      <Tooltip
        placement="top"
        title={
          <div>
            <div>Full Quantity: {fullQty}</div>
            {looseUnits.map(unit => (
              <div key={unit._id}>
                {unit.name}: {unit.looseQty}
              </div>
            ))}
          </div>
        }
      >
        <span className="flex items-center gap-2">
          <span>{fullQty} F</span>

          {looseUnits.length > 0 && (
            <>
              <Divider type="vertical" />
              {looseUnits.map(unit => (
                <span key={unit._id}>
                  {unit.looseQty} L
                </span>
              ))}
            </>
          )}
        </span>
      </Tooltip>
    );
  };

  const getStockAfterText = (record) => {
    if (!record.units || record.units.length === 0) {
      return `${record.stockAfter} F`;
    }

    const fullQty = Math.floor(record.stockAfter);

    const looseUnits = record.units
      .map(unit => {
        const looseQty = Math.floor(((record.stockAfter - fullQty) * unit.conversion) + 1e-6);
        return { ...unit, looseQty };
      })
      .filter(unit => unit.looseQty > 0);

    let text = `${fullQty} F`;
    if (looseUnits.length > 0) {
      text += ' | ';
      text += looseUnits.map(unit => `${unit.looseQty}L`).join(' | ');
    }

    return text;
  };

  /*   const formatOpLabel = (op = "", number = "") => {
      if (!op) return null;
  
      const lowerOp = op.toLowerCase();
  
      if (
        /(inventory|product)/.test(lowerOp)
      ) {
        return null;
      }
  
      const cleaned = lowerOp
        .replace(/\b(create|update|delete)\b/g, "")
        .replace(/\binvoices\b/g, "invoice")
        .replace(/\s+/g, " ")
        .trim();
  
      if (!cleaned) return null;
  
      const formatted =
        cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
  
      return `<strong>${formatted} Number : </strong>${number}`;
    }; */

  const formatOpLabel = (op = "", number = "", note = "") => {
    if (!op) return null;

    const lowerOp = op.toLowerCase().trim();
    const lowerNote = note ? note.toLowerCase().trim() : "";

    const opPrefixMap = {
      inventory: "BATCH",
      transfer: "TR",
      receive: "RECEIVED",
      invoices: "INV",
      "sales return": "SR",
      purchase: "PO",
      "purchase return": "PR",
    };

    if (lowerNote && lowerNote.includes("inventory")) {
      return `<strong>Number:</strong> #BATCH-${number}`;
    }

    const prefix = Object.keys(opPrefixMap).find((key) =>
      lowerOp.includes(key)
    );

    if (!prefix) return `<strong>Number:</strong> ${number}`;

    const formattedNumber = `${opPrefixMap[prefix]}-${number}`;

    return `<strong>Number:</strong> #${formattedNumber}`;
  };

  const formatOpLabelForCSV = (op = "", number = "", note = "") => {
    if (!op) return null;

    const lowerOp = op.toLowerCase().trim();
    const lowerNote = note ? note.toLowerCase().trim() : "";

    const opPrefixMap = {
      inventory: "BATCH",
      transfer: "TR",
      receive: "RECEIVED",
      invoices: "INV",
      "sales return": "SR",
      purchase: "PO",
      "purchase return": "PR",
    };

    if (lowerNote && lowerNote.includes("inventory")) {
      return `<strong>Number:</strong> #BATCH-${number}`;
    }

    const prefix = Object.keys(opPrefixMap).find((key) =>
      lowerOp.includes(key)
    );

    if (!prefix) return `<strong>Number:</strong> ${number}`;

    const formattedNumber = `${opPrefixMap[prefix]}-${number}`;

    return `Number: ${formattedNumber}`;
  };

  const downloadPDF = () => {
    if (!filteredData || filteredData.length === 0) {
      toast.error("No data to export");
      return;
    }

    const doc = new jsPDF('landscape');

    const productName = productInfo?.name || "N/A";
    const itemCode = productInfo?.item_code || "N/A";
    const branchName = filteredData[0]?.branch || "N/A";

    doc.setFontSize(18);
    doc.text('Stock Ledger Report', 14, 15);
    doc.setFontSize(10);
    doc.text(`Generated on: ${dayjs().format('YYYY-MM-DD HH:mm:ss')}`, 14, 22);
    doc.text(`Product: ${productName}`, 14, 28);
    doc.text(`Item Code: ${itemCode}`, 14, 34);
    doc.text(`Branch: ${branchName}`, 14, 40);
    doc.text(`Total Records: ${filteredData.length}`, 14, 46);

    const tableData = filteredData.map((item, index) => {
      const d = new Date(item.date);
      const formattedDate = d.toLocaleDateString("en-GB") + " " +
        d.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

      const movement = item.movement === 'in' ? '+' : '-';
      const unit = item.ismainunit ? 'F' : 'L';
      const operationDetails = `${item.type} | ${item.details?.operation || ''} | ${formatOpLabelForCSV(item.type, item.number, item.details?.operation)}`;

      return [
        index + 1,
        formattedDate,
        item.batchNumber,
        item.expiryDate || '',
        `${movement} ${item.quantity?.toFixed(0)} ${unit}`,
        item.foc || 0,
        getStockAfterText(item) || '0',
        item.user,
        operationDetails
      ];
    });

    autoTable(doc, {
      startY: 51,
      head: [[
        'S.No',
        'Date & Time',
        'Batch Number',
        'Expiry Date',
        'Quantity',
        'FOC Quantity',
        'Stock After Transaction',
        'User',
        'Details'
      ]],
      body: tableData,
      theme: 'grid',
      styles: {
        fontSize: 7,
        cellPadding: 2,
        overflow: 'linebreak',
        cellWidth: 'wrap'
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: 'bold'
      },
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 35 },
        2: { cellWidth: 40 },
        3: { cellWidth: 25 },
        4: { cellWidth: 15 },
        5: { cellWidth: 15 },
        6: { cellWidth: 20 },
        7: { cellWidth: 25 },
        8: { cellWidth: 80 },
      },
      didDrawPage: (data) => {
        doc.setFontSize(8);
      }
    });

    doc.save(`stock-ledger-full-${dayjs().format('YYYY-MM-DD-HHmm')}.pdf`);
    toast.success(`PDF exported with ${filteredData.length} records`);
  };

  const downloadCSV = () => {
    if (!filteredData || filteredData.length === 0) {
      toast.error("No data to export");
      return;
    }

    const headers = [
      'S.No',
      'Date & Time',
      'Batch Number',
      'Expiry Date',
      'Quantity',
      'FOC Quantity',
      'Stock After Transaction',
      'User',
      'Details'
    ];

    const csvData = filteredData.map((item, index) => {
      const d = new Date(item.date);
      const formattedDate = d.toLocaleDateString("en-GB") + " " +
        d.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });

      const movement = item.movement === 'in' ? '+' : '-';
      const unit = item.ismainunit ? 'F' : 'L';
      const operationDetails = `${item.type} | ${item.details?.operation || ''} | ${formatOpLabelForCSV(item.type, item.number, item.details?.operation)}`;

      return [
        index + 1,
        formattedDate,
        item.batchNumber,
        item.expiryDate,
        `${movement} ${item.quantity?.toFixed(0)} ${unit}`,
        item.foc || 0,
        getStockAfterText(item) || '0',
        item.user,
        operationDetails
      ];
    });

    const productName = filteredData[0]?.productName || "N/A";
    const branchName = filteredData[0]?.branch || "N/A";

    const csvContent = [
      `Product,${productInfo?.name || "N/A"}`,
      `Item Code,${productInfo?.item_code || "N/A"}`,
      `Branch,${branchName}`,
      '',
      headers.join(','),
      ...csvData.map(row =>
        row.map(cell => {
          const cellStr = String(cell || '');
          if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
            return `"${cellStr.replace(/"/g, '""')}"`;
          }
          return cellStr;
        }).join(',')
      )
    ].join('\n');

    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.href = url;
    link.download = `stock-ledger-full-${dayjs().format('YYYY-MM-DD-HHmm')}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    toast.success(`CSV exported with ${filteredData.length} records`);
  };

  const formdata = (data) => {
    if (!data?.product) {
      setProductSearchAlert(true);
      return;
    }

    setProductSearchAlert(false);

    fetchStockData({
      ...data,
    });
  };

  const paginationdata = (data) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: data.currentPage,
    }));
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>

      <Loadercomponent loader={loader}>
        <div className="flex justify-between gap-2 mt-4">
          {/* <div className="mt-4 p-3 bg-gray-50 border rounded text-xs text-gray-600">
            <div className="flex items-start">
              <InfoCircleOutlined className="mr-2 mt-0.5" />
              <div>
                <p className="font-medium mb-1">Quantity Definitions:</p>
                <ul className="list-disc pl-4 space-y-1">
                  <li>
                    <span className="font-medium">F :</span> Full Quantity
                  </li>
                  <li>
                    <span className="font-medium">L :</span> Loose Quantity
                  </li>
                  <li>
                    <span className="font-medium">FOC :</span> Free of Cost (always in Full Quantity)
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
          <div className="text-sm text-gray-800 flex flex-col gap-2">
            <div className="flex gap-2">
              <span className="font-semibold w-28">Product Name :</span>
              <span>{filteredData?.[0]?.productName || "-"}</span>
            </div>
            <div className="flex gap-2">
              <span className="font-semibold w-28">Item Code :</span>   {/* ← added */}
              <span>{productInfo?.item_code || "-"}</span>
            </div>

            <div className="flex gap-2">
              <span className="font-semibold w-28">Branch :</span>
              <span>{filteredData?.[0]?.branch || "-"}</span>
            </div>
          </div>
          <div className="flex gap-2">
            <Button
              icon={<DownloadOutlined />}
              onClick={downloadCSV}
            >
              CSV
            </Button>
            <Button
              icon={<PrinterOutlined />}
              onClick={downloadPDF}
            >
              PDF
            </Button>
          </div>
        </div>
        {productSearchAlert ? (
          <Alert
            className="mt-4"
            message="Search Required"
            description="Please enter the product name first to view the ledger list showing the stock movement for that product."
            type="success"
            showIcon
          />
        )
          : (
            <Table
              head={tables}
              body={body}
              pagination={pagination}
              paginationdata={paginationdata}
              componentRef={componentRef}
              summary={1}
            />
          )}
      </Loadercomponent>
    </Header >
  );
};

export default StockLedgerReport;